import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Grid, Icon } from 'semantic-ui-react';

import LookUpContainer from 'PointOfSale/modules/lookup/container/LookUpContainer';
import AmountCalculatorContainer from 'PointOfSale/modules/individualServing/container/AmountCalculatorContainer';
import ServingFoodItems from 'PointOfSale/modules/individualServing/container/ServingFoodItems';
import AdditionalFoodItemContainer from 'PointOfSale/modules/individualServing/container/AdditionalFoodItem';
import * as POSSelectors from 'PointOfSale/selectors';
import MessageContainer from '../component/MessageContainer';
import { changeQueueStatus } from 'PointOfSale/modules/queue/state/actions';
import { QueueStatusEnum } from 'PointOfSale/modules/common/constants';

class IndividualServingContainer extends Component {
  state = {
    tabMenus: this.props.tabMenus,
    tabKey: 'All Food Items',
  };

  onItemCategoryClick = tab => {
    const key = tab.key;
    const tabMenus = this.state.tabMenus.map(tab => {
      tab.selected = tab.key === key;
      return tab;
    });
    this.setState({ tabKey: key, tabMenus });
  };

  componentDidMount() {
    if (this.props.queueStatus === QueueStatusEnum.ON) {
      this.props.changeQueueStatus(QueueStatusEnum.PAUSED);
    }
  }

  render() {
    const { showLookUp, symbolIndicator, match } = this.props;
    const { tabKey, tabMenus } = this.state;
    const { Id } = match.params;

    if (showLookUp) {
      return <LookUpContainer />;
    }

    if (Id === 'new') {
      return (
        <React.Fragment>
          <div className="auto-serve-empty-queue-msg">
            <Icon name="info circle" size="large" />
            <span>The queue is empty</span>
          </div>
        </React.Fragment>
      );
    }

    return (
      <div className="flex-1 flex flex-col flex-no-wrap">
        <ServingFoodItems
          tabMenus={tabMenus}
          onItemCategoryClick={this.onItemCategoryClick}
          currentSelectedTabMenu={tabKey}
        />
        <Grid className="flex flex-col flex-1 bottom-tray pad-slim-top">
          <MessageContainer symbolIndicator={symbolIndicator} />
          <Grid.Row className="flex flex-1 flex-no-wrap min-h-0">
            <Grid.Column width="7" className="flex flex-col pad-slim-right">
              <AmountCalculatorContainer />
            </Grid.Column>
            <Grid.Column width="9" className="flex flex-col pad-slim-left">
              <AdditionalFoodItemContainer />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tabMenus: POSSelectors.getSelectedMealTypesTabsMenus(state),
  showLookUp: POSSelectors.getShowLookUp(state),
  symbolIndicator: POSSelectors.getProfileSymbolIndicator(state),
  fetching: POSSelectors.getFetching(state),
  queueStatus: POSSelectors.getQueueStatus(state),
});

const mapDispatchToProps = {
  changeQueueStatus,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IndividualServingContainer);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/container/index.js